<template>
  <div class="GeneralDropdownListCrud disable-ske">
    <span
      class="label d-flex align-items-center p-1 pl-2"
      @click="adding = !adding"
    >
      <svg class="mr-2" :class="{adding}" width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
          <circle cx="7" cy="7" r="6.5" style="fill: var(--mint-green);stroke: var(--mint-green);stroke-linecap: round;stroke-linejoin: round"></circle>
          <g>
            <line x1="7" y1="4" x2="7" y2="10" style="fill: none;stroke: white;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="4" y1="7" x2="10" y2="7" style="fill: none;stroke: white;stroke-linecap: round;stroke-linejoin: round"></line>
          </g>
        </g></g>
      </svg>

      {{ placeholder }}
    </span>

    <CheckboxOptions v-if="adding" ref="assign-to-website-checkbox"
      :selected.sync="dropdownSelectedItems"

      :endpoint="endpoint"
      :search-query="searchQuery"
      :item-name="searchQuery"
      :type="searchQuery"
      :hide-handle="true"
      :default-opened="true"
      dropdownWrapperClass="list-crud-dropdown-wrapper"

      class="options-dropdown"
    >
      <template #above-input>
        <span class="label input-label d-flex align-items-center p-1 pl-2">
          {{ placeholder }}
        </span>
      </template>

      <span></span>

      <template v-if="dropdownSelectedItems.length" #end-of-list>
        <div class="d-flex">
          <button class="mx-2 btn btn-primary flex-grow-1" @click="saveItems">
            Opslaan
          </button>
        </div>
      </template>
    </CheckboxOptions>
    <ul v-if="selectedItems.length" class="selected-items">
      <transition-group
        @enter="enter"
        @leave="leave"
      >
        <ListItem v-for="(item, index) in selectedItems" :key="item.uid || item.id"
          :item="item"
          :item-name="searchQuery"

          @remove="remove(index)"
        />
      </transition-group>
    </ul>
      
  </div>
</template>

<script>

import CheckboxOptions from "../../../../layout/Table/DropdownCheckboxTableFilters/CheckboxOptions.vue"
import ListItem from "./ListItem.vue"

import transitionFunctionConstructor from "../../../../mixins/transitionFunctionConstructor"

export default {
  mixins: [transitionFunctionConstructor()],
  components: {
    CheckboxOptions,
    ListItem
  },
  props: {
    placeholder: String,
    endpoint: String,
    searchQuery: String,
  },
  data() {
    return {
      adding: false,

      dropdownSelectedItems: [],
      selectedItems: [],
    }
  },
  methods: {
    checkPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (this.$el === node) {
          found = true
          break
        }
      }
      if (!found) this.adding = false
    },
    saveItems() {
      this.selectedItems = this.dropdownSelectedItems.slice()
      this.adding = false
    },
    remove(index) {
      this.selectedItems.splice(index, 1)
    },
  },
  watch: {
    adding(val) {
      if (val) {
        window.addEventListener("click", this.checkPath, {passive: true})
        this.dropdownSelectedItems = this.selectedItems.slice()
      } else {
        this.dropdownSelectedItems = []
        window.removeEventListener("click", this.checkPath, {passive: true})
      }
    },
    selectedItems(items) {
      this.$emit("input", items)
    }
  },
}
  
</script>

<style>

.GeneralDropdownListCrud .list-crud-dropdown-wrapper {
  box-shadow: none;
  border: 1px solid #33C9D2;

  width: calc(100% - 24px);
  margin-left: 24px;
  transform: translateY(-55px);
}

.GeneralDropdownListCrud .checkbox-options-input {
  padding-top: 0px !important;
}

</style>

<style scoped>

.GeneralDropdownListCrud + .GeneralDropdownListCrud{ 
  margin-top: 8px;
}

.adding {
  opacity: 0;
}

.selected-items {
  margin-left: 37px;
}

.label {
  color: var(--mint-green);
  font-weight: 700;
  cursor: pointer;
  border-radius: 1px;
  border: 1px solid transparent;
  transition-duration: .15s;
}

.label:hover {
  border: 1px solid var(--mint-green);
}

.input-label:hover {
  border: 1px solid transparent;
  cursor: initial;
}

.options-dropdown {
  width: 100%;
}

</style>
